import { useState } from 'react'

function useFormData<T>(initialFormData: T) {
    const [formData, setFormData] = useState<T>(initialFormData);
    const resetFormData = () => {
        setFormData(initialFormData);
    }

    function handleFormDataChange<D extends keyof T,>(key: D, value: T[D]) {
        setFormData((prev: T) => ({ ...prev, [key]: value }))
    }
    return {
        formData,
        resetFormData,
        handleFormDataChange,
        setFormData,
    }
}

export default useFormData